module.exports = __webpack_public_path__ + "static/wireframe-ad354c3b262c9c11c315b6bec1c8b2e5.jpg";